"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function EnterpriseworkloadsGreenMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M10.282.794c-1.502 0-2.888.834-3.697 2.223a.323.323 0 01-.27.16.293.293 0 01-.308-.08A2.079 2.079 0 004.66 2.62c-1.194 0-2.195 1.072-2.195 2.343 0 .595.192 1.151.577 1.588.077.119.116.278.077.397-.038.159-.192.238-.346.238C1.656 7.306.77 8.337.77 9.568c0 1.31 1.001 2.343 2.195 2.343h4.621V9.568c0-.873.693-1.588 1.54-1.588h.501c.193-.437.578-.715 1.04-.715h3.966V4.844c0-2.343-1.848-4.05-4.351-4.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M7.586 11.91h-4.62C1.77 11.91.77 10.879.77 9.569c0-1.23.886-2.263 2.041-2.342.154 0 .27-.12.347-.238.038-.16.038-.318-.077-.397a2.365 2.365 0 01-.578-1.589c0-1.31 1.001-2.342 2.195-2.342.5 0 .924.159 1.348.476.077.04.154.08.27.04.115 0 .23-.08.269-.159C7.394 1.627 8.78.794 10.282.794c2.503 0 4.351 1.707 4.351 4.05v2.422h.463c.115 0 .192 0 .307.04V4.843c0-2.82-2.156-4.844-5.121-4.844-1.656 0-3.158.834-4.12 2.223a2.711 2.711 0 00-1.464-.397c-1.617 0-2.965 1.43-2.965 3.137 0 .556.154 1.111.385 1.588C.886 6.948 0 8.139 0 9.568c0 1.747 1.348 3.137 2.965 3.137h4.621v-.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M11.394.873c-.277-.04-.516-.08-.794-.08-1.548 0-2.977.835-3.811 2.224a.334.334 0 01-.278.16c-.119.039-.238 0-.318-.08a2.156 2.156 0 00-1.35-.477c-1.23 0-2.262 1.072-2.262 2.343 0 .595.198 1.151.595 1.588.08.119.12.278.08.397-.04.119-.199.238-.358.238-1.19.12-2.104 1.151-2.104 2.382 0 .596.198 1.112.556 1.549L11.394.873z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M3.262 8.679c0-.136.277-.245.618-.245h5.56c.341 0 .618.11.618.245v3.433c0 .136-.277.246-.618.246H3.88c-.341 0-.618-.11-.618-.246V8.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.062 9.234v2.324h5.196V9.234H4.062zm-.182-.8c-.341 0-.618.11-.618.245v3.433c0 .136.277.246.618.246h5.56c.341 0 .618-.11.618-.246V8.68c0-.136-.277-.245-.618-.245H3.88z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M3.262 11.953c0-.136.277-.246.618-.246h5.56c.341 0 .618.11.618.246v3.433c0 .136-.277.246-.618.246H3.88c-.341 0-.618-.11-.618-.246v-3.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.062 12.507v2.325h5.196v-2.325H4.062zm-.182-.8c-.341 0-.618.11-.618.246v3.433c0 .136.277.246.618.246h5.56c.341 0 .618-.11.618-.246v-3.433c0-.136-.277-.246-.618-.246H3.88z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M8.18 5.492a.7.7 0 01.7-.7h6.3a.7.7 0 01.7.7V15.3a.7.7 0 01-.7.7h-6.3a.7.7 0 01-.7-.7V5.492z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.18 5.791V15h5.7V5.791h-5.7zm-.3-1a.7.7 0 00-.7.7V15.3a.7.7 0 00.7.7h6.3a.7.7 0 00.7-.7V5.492a.7.7 0 00-.7-.7h-6.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.487 8.49H10.52v-1h2.968v1zM12.03 13.149a.735.735 0 100-1.47.735.735 0 000 1.47zm0 .8a1.535 1.535 0 100-3.07 1.535 1.535 0 000 3.07z",
    clipRule: "evenodd"
  }));
}

EnterpriseworkloadsGreenMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
EnterpriseworkloadsGreenMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = EnterpriseworkloadsGreenMultitoneFilled;
exports["default"] = _default;